<div class="columns">
  <div class="column">
    <app-header
      header="dws.title"
      subHeader="dws.subtitle"
      class="mb-5"
    ></app-header>
  </div>
</div>

<div class="fixed-grid">
  <div class="grid is-gap-3">
    <div class="cell">
      <app-action-box
        class="mb-4 is-flex is-fullheight"
        header="dws.basicInfo.info.title"
        iconSrc="/assets/icons/icon-info.svg"
        iconClass="p-4"
        hideCtaButton
        isNotClickable
      >
        <div class="p-4">
          <p class="title is-size-5" translate>dws.basicInfo.basicInfo</p>

          <div class="columns">
            <div class="column">
              <span translate>dws.basicInfo.name</span>
            </div>
            <div class="column is-flex is-justify-content-flex-end">
              <strong>{{ dwsConfig?.name }}</strong>
            </div>
          </div>

          <div class="is-flex is-align-items-center is-flex-direction-column">
            <figure class="image logo">
              <img [src]="$safeNavigationMigration(dwsConfig?.logo)" />
            </figure>
            <p class="has-text-grey">Ihr Logo</p>
          </div>
        </div>
      </app-action-box>
    </div>

    <div class="cell">
      <app-action-box
        class="mb-4 is-flex is-fullheight"
        header="dws.links.info.title"
        subHeader="dws.links.info.subtitle"
        icon="Network Arrow"
        iconClass="p-4"
        hideCtaButton
        isNotClickable
      >
        <div class="p-4 columns">
          <div class="column is-3 is-flex is-flex-direction-column">
            <span translate>dws.links.test</span>
            <span translate>dws.links.prod</span>
          </div>
          <div
            class="column is-flex is-flex-direction-column is-justify-content-flex-end"
          >
            <a
              class="has-text-primary has-text-weight-bold has-text-right"
              target="_blank"
              [href]="testUrl"
            >
              {{ testUrl }}
            </a>
            <a
              class="has-text-primary has-text-weight-bold has-text-right"
              target="_blank"
              [href]="prodUrl"
            >
              {{ prodUrl }}
            </a>
          </div>
        </div>
      </app-action-box>
    </div>
  </div>
</div>
